function watchEvents(modal, iframe, iframeSrc) {

  iframe.src = iframeSrc;

  document.addEventListener("keydown", (event) => {
    if (event.keyCode === 27) {
      modal.classList.remove('modal--active');
    }
  });

  modal.firstElementChild.addEventListener('click', () => {
    modal.classList.remove('modal--active');
    iframe.removeAttribute("src");
  });
}

function Modal() {
  let modalTrigger = document.querySelectorAll('.text-image__videoIcon');
  if (typeof modalTrigger != "undefined" && modalTrigger != null) {
    Array.prototype.forEach.call(document.querySelectorAll('.text-image__videoIcon'), function(trigger){
      let modal = trigger.parentElement.lastElementChild;
      let iframe = modal.lastElementChild;
      const iframeSrc = iframe.src;
      trigger.addEventListener('click', () => {
        trigger.parentElement.lastElementChild.classList.add('modal--active');
        watchEvents(modal, iframe, iframeSrc);
      });
    });
  }
}

export default Modal;


// WEBPACK FOOTER //
// ./src/js/app/components/Modal.js